<div
  [ngStyle]="{ 'margin-left': '-24px', 'margin-right': '-24px' }"
  class="u-padding-0-24 u-paddingBottom-16 u-borderBottom-grey100"
  mat-dialog-title
>
  <span i18n="@@confirmPromptDialog.title"
    >{data.title, select, other {{{ data.title }}} }</span
  >
</div>
<mat-dialog-content>
  <div class="u-marginBottom-16 u-text-maxWidth">
    <ng-container
      i18n="@@confirmPromptDialog.content"
      *nzStringTemplateOutlet="data.content"
      >{data.content, select, other {{{ data.content }}} }</ng-container
    >
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end center"
  [ngStyle]="{ 'margin-left': '-24px', 'margin-right': '-24px' }"
>
  <div class="u-padding-0-8" fxLayout="row" fxLayoutGap="8px">
    <ng-container *ngIf="data.confirm">
      <button
        mat-raised-button
        [mat-dialog-close]="data"
        [color]="data.color || 'primary'"
        fxFlexOrder="2"
      >
        <span i18n="@@confirmPromptDialog.confirm.buttonLabel"
          >{data.confirm, select, other {{{ data.confirm }}} }</span
        >
      </button>
    </ng-container>
    <ng-container *ngIf="data.cancel">
      <button mat-button [mat-dialog-close] fxFlexOrder="1">
        <span i18n="@@confirmPromptDialog.cancel.buttonLabel"
          >{data.cancel, select, other {{{ data.cancel }}} }</span
        >
      </button>
    </ng-container>
  </div>
</mat-dialog-actions>
